// extracted by mini-css-extract-plugin
module.exports = {"tooltip_item_container":"styles_tooltip_item_container__zOWt1"};